import React from 'react'
import { Tooltip } from 'antd'

const LayerControl = ({ name, title, groupName, isCurrent, isShow, toggleLayer, settingLayer, infoLayer, children }) => {
    return (
        <li className={isCurrent ? 'on' : ''}>
            <Tooltip placement="top" title="显示/隐藏" color='#8c8c8c'>
                <div className={isShow ? 'open' : 'close'} onClick={() => toggleLayer(groupName)}></div>
            </Tooltip>
            <div
                className="text"
                onClick={() => { if (settingLayer) settingLayer() }}
            >{name}</div>
            <div className="button">
                <Tooltip placement="topLeft" title={title} arrowPointAtCenter>
                    <span className="list_icon1" onClick={() => { if (infoLayer) infoLayer() }}></span>
                </Tooltip>
                <span className="list_icon2" onClick={() => { if (settingLayer) settingLayer() }}></span>
                <span className="list_icon3"></span>
            </div>
            {children}
        </li>
    )
}

export default LayerControl